import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/loginPage/LoginPage";

const AuthNavigator = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
};

export default AuthNavigator;
